import { getLogger } from "@goodgamestudios/logger";
import { FPS_MEASUREMENT_LOGGER } from "./IMeasurements";
/**
 * Created by rkamysz on 1/15/2015.
 */

import { ExternalLoggingConstants } from "../externalLogging/ExternalLoggingConstants";
import { BasicLogObjectFactory } from "../externalLogging/factories/BasicLogObjectFactory";
import { AbstractLogObject } from "../externalLogging/logObjects/AbstractLogObject";

export class MeasurementLogFactory extends BasicLogObjectFactory {
    private static PERFORMANCE_MONITORING_LOG: number = 40;

    private _log: AbstractLogObject;
    private _eventData: Object;

    private logger = getLogger(FPS_MEASUREMENT_LOGGER);

    constructor(eventData: Object) {
        super();
        this._subErrorId = 40002;
        this._eventData = eventData;
    }

    public create(): AbstractLogObject {
        this._log = super.create();

        this.setLogData();
        this.logger.debug("Executing old method, result not guaranteed");

        return this._log;
    }

    private setLogData(): void {
        this._log.logData[ExternalLoggingConstants.PARAM_LOG_TYPE] = ExternalLoggingConstants.LOGGING_TYPE_LOG;
        this._log.logData[ExternalLoggingConstants.PARAM_LOG_EVENT_ID] = MeasurementLogFactory.PERFORMANCE_MONITORING_LOG;

        for (let key in this._eventData) {
            this._log.logData[key] = this._eventData[key];
        }
        this.logger.debug("Executing old method, result not guaranteed");
    }

}
